import isNil from 'lodash/isNil';

import { CustomDimensions } from '../types/custom-dimensions';

export const getCustomDimensionWithStringValue = (
  cd: Partial<CustomDimensions>
): { [k in keyof Partial<CustomDimensions>]: string } => (
  Object.keys(cd).reduce<{ [k in keyof Partial<CustomDimensions>]: string }>(
    (acc, key) => {
      if (key === 'collectionInfo' && cd.collectionInfo) {
        const { type, name, id } = cd.collectionInfo;

        acc[key] = `${type}.${name}.${id}`;

        return acc;
      }

      if (
        (key === 'agencyInfo' && cd.agencyInfo)
        || (key === 'campaignInfo' && cd.campaignInfo)
      ) {
        const obj = cd[key] || null;

        if (obj === null) {
          return acc;
        }

        const { id, name } = obj;

        acc[key] = `${id}.${name}`;

        return acc;
      }

      const restOfKeys = [
        'brandId',
        'influencerId',
        'organizationId',
        'organizationType',
        'subcampaignId',
        'userId'
      ];

      if (restOfKeys.indexOf(key) > -1) {
        if (!isNil(cd[key])) {
          acc[key] = String(cd[key]);
        }
      }

      return acc;
    },
    {}
  )
);
